import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Collapse,
  IconButton,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import {
  hideApiLoader,
  showApiLoader,
} from "../../../../redux/tool-webjam/actions";
import { getPaidRoomPaymentHistory } from "../../../paymentRequest";
import { useDispatch, useSelector } from "react-redux";
import { setPaidRoomPaymentHistory } from "../payment-reducer/actions";
import { paginationObject } from "../Utils";
import { usePrevious } from "../../../Utils";
import { FEATURE_CUSTOM_PAYMENT } from "../../../../constant";
import { Constant } from "../../../../../webjam/constant";
import { dateFormatter } from "../AbstractHelperComponent";
import { isMobileBrowserC } from "../../../../Utils";
import { ct } from "../../../../constant-Utils";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--theme-primary-color)",
    color: theme?.palette?.common?.white,
    fontSize: 16,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 16,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const currencyObject = {
  USD: "$",
};

const PaidRoomTable = () => {
  const { paidRoomHistory } = useSelector(
    (state) => state[FEATURE_CUSTOM_PAYMENT]
  );
  const isMobile = isMobileBrowserC();
  const [isLoading, setIsLoading] = useState(false);
  const [totalRecord, setTotalRecord] = useState(0);
  const [recordPerPage, setRecordPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [pageNo, setPageNo] = useState({
    currentPage: 0,
    nextPage: 0,
    prevPage: 0,
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentActiveId, setCurrentActiveId] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setCurrentActiveId(event.currentTarget.id);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  const { list: paymentHistory } = paidRoomHistory;

  // Handle number of record per page
  const prevPerPage = usePrevious(recordPerPage);
  useEffect(() => {
    console.log("pagination change ", recordPerPage, "prev ", prevPerPage);
    if (prevPerPage != undefined && prevPerPage != recordPerPage) {
      if (recordPerPage > 0) {
        fetchData("?page=" + 1 + "&limit=" + recordPerPage);
      }
    }
  }, [recordPerPage]);

  const fetchData = (pagination = "") => {
    setIsLoading(true);
    dispatch(showApiLoader());
    getPaidRoomPaymentHistory(pagination)
      .then((res) => {
        if (res.status == 1) {
          const data = res.data.data;
          dispatch(
            setPaidRoomPaymentHistory({
              list: data.rooms,
              pagination: data.pagination,
            })
          );
          setTotalRecord(data.pagination.count);
          setRecordPerPage(data.pagination.page.perPage);
          setPageNo(data.pagination.page);
        } else {
          dispatch(
            setPaidRoomPaymentHistory({
              list: [],
              pagination: paginationObject,
            })
          );
          setTotalRecord(0);
          setRecordPerPage(10);
          setPageNo({
            currentPage: 0,
            nextPage: 0,
            prevPage: 0,
          });
        }
      })
      .catch((e) => {
        dispatch(
          setPaidRoomPaymentHistory({
            list: [],
            pagination: paginationObject,
          })
        );
        setTotalRecord(0);
        setRecordPerPage(10);
        setPageNo({
          currentPage: 0,
          nextPage: 0,
          prevPage: 0,
        });
      })
      .finally(() => {
        dispatch(hideApiLoader());
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleRoomAction = (roomName) => {
    if (roomName) {
      const socialUrl = Constant.App.socialUrl;
      window.open(socialUrl + "/webcam/" + roomName, "_self");
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const { target } = event;
    setRecordPerPage(+target.value);
    setPage(0);
  };

  const getTransactionId = (obj) => {
    if (obj?.userSubscription?.status == "trialing") {
      return obj?.transaction?._id || "-";
    }
    return obj?.transaction?.transaction_id || "N/A";
  };

  return (
    <div>
      {isMobile && (
        <Menu
          id={"basic-popup"}
          autoFocus={false}
          anchorEl={anchorEl}
          open={open}
          className="root muiMenuWrapper"
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-popup",
          }}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <MenuItem
            sx={{ paddingTop: "0px", paddingBottom: "0px" }}
            onClick={() => {
              const activeObj = paymentHistory.find(
                (r) => r?._id === currentActiveId
              );
              handleRoomAction(activeObj?.room?.groupName)
              handleClose();
            }}
          >
            <i className="fa fa-video-camera payment-theme-icon pointer theme-font-color"></i>
            <Typography>
              {paymentHistory?.find(r => r?._id === currentActiveId)?.is_room_owner ? ct("rta-trmc.dashboard.paymentHistory.typography.startRoom") : ct("rta-trmc.dashboard.paymentHistory.typography.joinRoom")}
            </Typography>
          </MenuItem>
        </Menu>
      )}
      {!isMobile && <TableContainer>
        <Table aria-label="customized table" stickyHeader>
          <TableHead>
            <TableRow>
              {/* <StyledTableCell /> */}
              <StyledTableCell>{ct("rta-trmc.dashboard.paymentHistory.typography.transactionId")}</StyledTableCell>
              <StyledTableCell>{ct("rta-trmc.dashboard.paymentHistory.typography.roomName")}</StyledTableCell>
              <StyledTableCell>{ct("rta-trmc.dashboard.paymentHistory.typography.amount")}</StyledTableCell>
              <StyledTableCell>{ct("rta-trmc.dashboard.paymentHistory.typography.paymentType")}</StyledTableCell>
              <StyledTableCell>{ct("rta-trmc.dashboard.paymentHistory.typography.paidTo")}</StyledTableCell>
              <StyledTableCell>{ct("rta-trmc.dashboard.paymentHistory.typography.receiveFrom")}</StyledTableCell>
              <StyledTableCell>{ct("rta-trmc.dashboard.paymentHistory.typography.date")}</StyledTableCell>
              <StyledTableCell className={isMobile ? "stickyActionHeader" : ""}>
                {ct("rta-trmc.dashboard.paymentHistory.typography.actions")}
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!isLoading && !paymentHistory.length && (
              <StyledTableRow className="w-100">
                <StyledTableCell
                  colSpan={8}
                  style={{ textAlign: "-webkit-center" }}
                >
                  {ct("Translate.typography.noRecordFound")}
                </StyledTableCell>
              </StyledTableRow>
            )}

            {paymentHistory.map((row, i) => (
              <ExpandedRow key={i} row={row} handleClick={handleClick} handleRoomAction={handleRoomAction} index={i} />
            ))}
          </TableBody>
          <TableFooter>
            {paymentHistory?.length && !isMobile ? (
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[10]}
                  count={totalRecord}
                  rowsPerPage={recordPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  sx={{
                    fontSize: 16,
                  }}
                  SelectProps={{
                    MenuProps: { classes: { paper: "invite-pagination" } },
                  }}
                  className="welcome-pagination"
                />
              </TableRow>
            ) : null}
          </TableFooter>
        </Table>
      </TableContainer>}
      {/* Mobile cards start here */}
      {isMobile && !isLoading && !paymentHistory?.length && (<div className="w-100 text-center" style={{ fontSize: '16px' }}>{ct("Translate.typography.noRecordFound")}</div>)}
      {isMobile && paymentHistory.map((row, i) => {
        return (<Card className="mb-5 custom-card-wrapper" key={i}>
          <CardHeader
            sx={{ paddingBottom: "0px" }}
          // \title={<div className="d-flex"><span><b>{ct("rta-trmc.dashboard.paymentHistory.typography.tnxId")} : </b></span><span className="ml-2">{getTransactionId(row)}</span></div>}
          />
          <CardContent sx={{ paddingTop: "0px" }}>
            <div className="d-flex"><Typography><b>{ct("rta-trmc.dashboard.paymentHistory.typography.tnxId")} : </b></Typography><Typography className="ml-2">{getTransactionId(row)}</Typography></div>
            <div className="d-flex"><Typography><b>{ct("rta-trmc.dashboard.paymentHistory.typography.roomName")} :</b></Typography><Typography className="ml-2">{row?.room?.groupName || "N/A"}</Typography></div>
            <div className="d-flex"><Typography><b>{ct("rta-trmc.dashboard.paymentHistory.typography.amount")} :</b></Typography><Typography className="ml-2">{row?.amount_total?.$numberDecimal
              ? currencyObject[row?.payCurrency] +
              "" +
              row?.amount_total?.$numberDecimal
              : "N/A"}</Typography></div>
            <div className="d-flex"><Typography><b>{ct("rta-trmc.dashboard.paymentHistory.typography.paymentType")} :</b></Typography><Typography className="ml-2">{!row?.is_room_owner ? ct("rta-trmc.dashboard.paymentHistory.typography.paid") : ct("rta-trmc.dashboard.paymentHistory.typography.receive")}</Typography></div>
            <div className="d-flex"><Typography><b>{ct("rta-trmc.dashboard.paymentHistory.typography.paidTo")} :</b></Typography><Typography className="ml-2">{!row?.is_room_owner ? row?.room?.userName : "N/A"}</Typography></div>
            <div className="d-flex"><Typography><b>{ct("rta-trmc.dashboard.paymentHistory.typography.receiveFrom")} :</b></Typography><Typography className="ml-2">{row?.is_room_owner ? row?.room?.userName : "N/A"}</Typography></div>
            <div className="d-flex"><Typography><b>{ct("rta-trmc.dashboard.paymentHistory.typography.date")} :</b></Typography><Typography className="ml-2">{row.createdAt ? dateFormatter(row.createdAt, "YYYY-MM-DD") : "N/A"}</Typography></div>
            <div className="w-100 mt-2"><Button
              id={row?.is_room_owner ? `start-room-${i}` : `join-room-${i}`}
              variant="contained"
              fullWidth
              size="small"
              startIcon={<i className="fa fa-video-camera"></i>}
              onClick={() => handleRoomAction(row?.room?.groupName)}
              sx={{
                fontSize: 14,
                backgroundColor: "var(--theme-primary-color)",
              }}
              className="p-theme-btn"
            >{row?.is_room_owner ? ct("rta-trmc.dashboard.paymentHistory.typography.startRoom") : ct("rta-trmc.dashboard.paymentHistory.typography.joinRoom")}</Button></div>
          </CardContent>
        </Card>)
      })}
      {/* Mobile cards end here */}
      {
        paymentHistory?.length && isMobile ? (
          <div className="mobile-pagination-wrapper">
            <TablePagination
              rowsPerPageOptions={[10]}
              count={totalRecord}
              rowsPerPage={recordPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                fontSize: 16,
              }}
              SelectProps={{
                MenuProps: { classes: { paper: "invite-pagination" } },
              }}
              className="welcome-pagination mobile-pagination"
            />
          </div>
        ) : null
      }
    </div>
  );
};

export default PaidRoomTable;

const ExpandedRow = ({ row, handleClick, handleRoomAction, index }) => {
  const isMobile = isMobileBrowserC();
  const [isExpanded, setIsExpanded] = useState(false);
  const getTransactionId = (obj) => {
    if (obj?.userSubscription?.status == "trialing") {
      return obj?.transaction?._id || "-";
    }
    return obj?.transaction?.transaction_id || "-";
  };
  return (
    <>
      <TableRow key={row._id} hover>
        {/* <StyledTableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? (
              <i className="fa fa-chevron-up" aria-hidden="true"></i>
            ) : (
              <i className="fa fa-chevron-down" aria-hidden="true"></i>
            )}
          </IconButton>
        </StyledTableCell> */}
        <StyledTableCell>{getTransactionId(row)}</StyledTableCell>
        <StyledTableCell>{row?.room?.groupName || "-"}</StyledTableCell>
        <StyledTableCell>
          {row?.amount_total?.$numberDecimal
            ? currencyObject[row?.payCurrency] +
            "" +
            row?.amount_total?.$numberDecimal
            : "-"}
          {/* {row?.amount_total?.$numberDecimal && <i className='fa fa-info-circle mr-2' aria-hidden='true'></i>} */}
        </StyledTableCell>
        <StyledTableCell>
          {!row?.is_room_owner ? ct("rta-trmc.dashboard.paymentHistory.typography.paid") : ct("rta-trmc.dashboard.paymentHistory.typography.receive")}
        </StyledTableCell>
        <StyledTableCell>
          {!row?.is_room_owner ? row?.room?.userName : "-"}
        </StyledTableCell>
        <StyledTableCell>
          {row?.is_room_owner ? row?.room?.userName : "-"}
        </StyledTableCell>
        <StyledTableCell>
          {row.createdAt ? dateFormatter(row.createdAt, "YYYY-MM-DD") : "-"}
        </StyledTableCell>
        <StyledTableCell className={isMobile ? "stickyActionColumn" : ""}>
          {isMobile ? (
            <i
              id={row._id}
              onClick={(e) => handleClick(e)}
              className="fa fa-ellipsis-h pointer theme-font-color"
              aria-hidden="true"
            ></i>
          ) : (
            <Tooltip
              title={row?.is_room_owner ? ct("rta-trmc.dashboard.paymentHistory.typography.startRoom") : ct("rta-trmc.dashboard.paymentHistory.typography.joinRoom")}
              arrow
            >
              <i
                id={row?.is_room_owner ? `start-room-${index}` : `join-room-${index}`}
                className="fa fa-video-camera payment-theme-icon pointer theme-font-color"
                onClick={() => handleRoomAction(row?.room?.groupName)}
              ></i>
            </Tooltip>
          )}
        </StyledTableCell>
      </TableRow>
      {/* // expanded table row */}
      {/* <TableRow>
        <StyledTableCell
          style={{ paddingBottom: 0, paddingTop: 0 }}
          colSpan={7}
        >
          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1, display:"flex", gap:"4" }}>
            <Typography sx={{padding:"8px"}}>{row?.is_room_owner ? "Receive From : " : "Paid To : "}</Typography><Typography sx={{padding:"8px"}}>{row?.room?.userName || "-"}</Typography>
            </Box>
          </Collapse>
        </StyledTableCell>
      </TableRow> */}
    </>
  );
};
